let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d5Oug")).then(() => parcelRequire('3Kcre'));